import { type PropsWithChildren } from 'react';

import { Text } from '@/components/typography';

const TooltipTitle = ({ children }: PropsWithChildren) => {
  const tooltipTitle = typeof children === 'string' ? children : undefined;

  return (
    <tr>
      <th
        className="max-w-90 overflow-hidden text-start text-ellipsis whitespace-nowrap"
        colSpan={3}
      >
        <Text variant="caption1" color="light-green" title={tooltipTitle}>
          {children || ''}
        </Text>
      </th>
    </tr>
  );
};

export default TooltipTitle;
